import { Dimensions, Platform } from 'react-native';
import * as Device from 'expo-device';

const { width, height } = Dimensions.get('window');
const isMobile: boolean = Platform.OS !== 'web' || width < 500 || height < 500 || Device.brand !== null;

export default isMobile;
